export function useEnvironment() {
 return process.env.NODE_ENV === 'development';
}